._textButton_1eq9b_1.btn-text {
  font-size: 14px; }
